import React from 'react';
import './CustomAlert.css';

interface CustomAlertProps {
  message: string;
  onClose: () => void;
  isConfirm?: boolean;
  onCancel?: () => void;
}

const CustomAlert: React.FC<CustomAlertProps> = ({ message, onClose, isConfirm, onCancel }) => {
  return (
    <div className="custom-alert-overlay" onClick={isConfirm ? onCancel : onClose}>
      <div className="custom-alert-container" onClick={(e) => e.stopPropagation()}>
        <div className="custom-alert-content">
          <p className="custom-alert-message">{message}</p>
        </div>
        {isConfirm ? (
          <div className="custom-alert-buttons">
            <button className="custom-alert-button cancel" onClick={onCancel}>
              취소
            </button>
            <button className="custom-alert-button" onClick={onClose}>
              확인
            </button>
          </div>
        ) : (
          <button className="custom-alert-button" onClick={onClose}>
            확인
          </button>
        )}
      </div>
    </div>
  );
};

export default CustomAlert;
